import { getUser } from "@api/user";
import { OIDC_COOKIES } from "@lib/auth";
import Cookies from "js-cookie";
import { atom, onMount } from "nanostores";
import type { User } from "src/types/user";
import { createFetcherStore } from "./fetcher";

export const $authed = atom<boolean>(false);

onMount($authed, () => {
  $authed.set(!!Cookies.get(OIDC_COOKIES.Claims));
});

export const $user = createFetcherStore<User>([$authed, "/v0.1/user"], {
  fetcher: getUser,
});
